import { useEffect } from 'react';
import { loadEmbeddedScript } from '../util';

const useBeaconSalesforceScript = () => {
  useEffect(() => {
    loadEmbeddedScript({
      scriptAsync: false,
      scriptDefer: false,
      scriptId: 'figoBeaconSalesforce',
      scriptSrc: process.env.REACT_APP_BEACON_SALESFORCE_SRC,
    });
  }, []);

  return {
    active: !!window.SalesforceInteractions,
  };
};

export { useBeaconSalesforceScript };
